import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import SmoothModal from "../../../components/Modals/SmoothModal";
import { Box, Button, FormControl, InputLabel, Select, TextField, Typography } from "@mui/material";
import provinces from "@doncicuto/es-provinces";
import municipalities from "@doncicuto/es-municipalities";
import { cambiarProveedor } from "./../../../services";
import { toast } from "react-toastify";


import {
    municipiosIniciales,
    cambiarFormatoNombre,
} from "../../../functions/funciones";

import { ordenarProvinciasYMunicipios } from "../../../functions/ordenarListas";

import LaeButton from "../../../components/Buttons/LaeButton";
import { UsuarioContext } from "../../../providers/userContext";

import { verificarCodigoPostal, verificarCorreo, verificarTelefono } from "../../../functions/validator/formValidator";

const EditarDatosProveedor = (props) => {
    const { t } = useTranslation(['suppliers', 'common']);

    const [editarDatos, setEditarDatos] = useState({});
    const [listadoMunicipios, setListadoMunicipios] = useState([]);

    useEffect(() => {
        setListadoMunicipios(
            municipiosIniciales(provinces, municipalities, props.data?.provincia)
        );
    }, [props.data]);


    function handleChange(evt) {
        const value = evt.target.value;
    
        setEditarDatos({
            ...editarDatos,
            [evt.target.name]: value
        });
    }
    const user = useContext(UsuarioContext);

    const editar = (data) => {
        let keys = Object.keys(data);
       
        let errores = false;

        keys.forEach(key => {
            switch (key) {
                case "codigoPostal":
                    let codigoPostalCorrecto = verificarCodigoPostal(data.codigoPostal);
                    if (!codigoPostalCorrecto) {
                        toast.error(t('messages.incorrectPostalCode'));
                        errores = true;
                    }
                    break;
                case "emailContacto":
                    let correoCorrecto = verificarCorreo(data.emailContacto);
                    if (!correoCorrecto) {
                        toast.error(t('messages.incorrectEmail'));
                        errores = true;
                    }
                    break;
                case "telefonoContacto":
                    let telefonoCorrecto = verificarTelefono(data.telefonoContacto);
                    if (!telefonoCorrecto) {
                        toast.error(t('messages.incorrectPhone'));
                        errores = true;
                    }
                    break;
                default:
                    break;
            }
        });


        if (errores) {
            return;
        }


        cambiarProveedor(user.nif, data).then(res => {
            
            if (res.status === 403) {
                toast.error(res.data.error[0]);
                
            }
            if (res.status >= 200 && res.status < 300) {
                toast.success(t('editModal.saveSuccess'));
                props.handleClose();
            }


        }).catch(err => {
            console.log(err);
            toast.error(t('editModal.saveError'));
        });
    };



    return (
        // <SmoothModal open={showModal} onClose={onClose} sx={{ width: 800 }}>
        <SmoothModal open={props.showModal}
            onClose={props.handleClose} sx={{ width: 800 }}>
            <Box className="lae-flex lae-flex-column">
                <Typography variant="h4">{t('editModal.title')}</Typography>
                <Box className="lae-flex lae-flex-row" sx={{ gap: 3 }}>
                    <TextField
                        id="razonSocial"
                        name="razonSocial"
                        label={t('editModal.fields.supplierName')}
                        fullWidth
                        size="small"
                        defaultValue={props.data?.razonSocial}
                        onChange={handleChange}
                    ></TextField>
                    <TextField
                        id="direccion"
                        name="direccion"
                        label={t('editModal.fields.address')}
                        fullWidth
                        size="small"
                        defaultValue={props.data?.direccion}
                        onChange={handleChange}
                    ></TextField>
                </Box>
                <Box className="lae-flex lae-flex-row" sx={{ gap: 3 }}>
                    <TextField
                        id="nombreContacto"
                        name="nombreContacto"
                        label={t('editModal.fields.contactPerson')}
                        fullWidth
                        size="small"
                        defaultValue={props.data?.nombreContacto}
                        onChange={handleChange}
                    ></TextField>
                    <TextField
                        id="emailContacto"
                        name="emailContacto"
                        label={t('editModal.fields.contactEmail')}
                        fullWidth
                        size="small"
                        defaultValue={props.data?.emailContacto}
                        onChange={handleChange}
                    ></TextField>
                </Box>
                <Box className="lae-flex lae-flex-row" sx={{ gap: 3 }}>
                    <TextField
                        type="tel"
                        id="telefonoContacto"
                        name="telefonoContacto"
                        label={t('editModal.fields.phone')}
                        fullWidth
                        size="small"
                        defaultValue={props.data?.telefonoContacto}
                        onChange={handleChange}
                    ></TextField>
                    <TextField
                        id="codigoPostal"
                        name="codigoPostal"
                        label={t('editModal.fields.postalCode')}
                        fullWidth
                        size="small"
                        defaultValue={props.data?.codigoPostal}
                        onChange={handleChange}
                    ></TextField>
                </Box>
                <Box className="lae-flex lae-flex-row" sx={{ gap: 3 }}>
                    <FormControl variant="outlined" style={{ width:'100%'}}>
                        <InputLabel htmlFor="provincia">{t('editModal.fields.province')}</InputLabel>
                        <Select
                            label={t('editModal.fields.province')}
                            native
                            name="provincia"
                            id="provincia"
                            style={{ textTransform: "uppercase" }}
                            onChange={handleChange}
                            defaultValue={props.data?.provincia}
                            size="small"
                            fullWidth
                        >
                            <option value=""></option>
                            {provinces.sort(ordenarProvinciasYMunicipios)?.map((e, i) => {
                                return (
                                    <option key={i} value={e.name}>
                                        {e.name}
                                    </option>
                                );
                            })}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" style={{ width:'100%'}}>
                        <InputLabel htmlFor="municipio">{t('editModal.fields.municipality')}</InputLabel>
                        <Select
                            label={t('editModal.fields.municipality')}
                            native
                            name="municipio"
                            id="municipio"
                            style={{ textTransform: "uppercase" }}
                            onChange={handleChange}
                            defaultValue={props.data?.municipio}
                            fullWidth
                            size="small"
                        >
                            <option value=""></option>
                            {listadoMunicipios
                                .sort(ordenarProvinciasYMunicipios)
                                ?.map((e, i) => {
                                    return (
                                        <option key={i} value={e.value}>
                                            {e.name}
                                        </option>
                                    );
                                })}
                        </Select>
                    </FormControl>
                </Box>
                <Box className="lae-flex lae-flex-row" sx={{ gap: 3 }}>
                    <Button
                        variant="contained"
                        sx={{
                            flex: 1,
                            backgroundColor: "whitesmoke",
                            color: "#92004D",
                            ":hover": { backgroundColor: "#92004D", color: "white" },
                            margin: 0,
                            p: 1,
                        }}
                        disableElevation
                        onClick={props.handleClose}
                    >
                        {t('common:actions.cancel')}
                    </Button>
                    <LaeButton sx={{ flex: 1 }} onClick={() => editar(editarDatos)}>
                        {t('common:actions.save')}
                    </LaeButton>
                </Box>
            </Box>
        </SmoothModal>
    );
};

export default React.memo(EditarDatosProveedor);
